import React from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import ConfigurationHeader from "./header";
import CustomInput from "../../../components/TextField/TextFeild";
import { updateUserProfile } from "../../../store/slices/authSlice";

// Formik validation schema
const validationSchema = Yup.object({
  stream: Yup.string().url().required("Stream Url is required"),
});

const Audio = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      stream: user?.attributes.stream,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const isForStation =  user?.attributes?.isOwner == false ? true : false ;
      dispatch(
        updateUserProfile({ message: "Stream Url Updated Successfully.", values ,isForStation})
      );
    },
  });

  return (
    <div className="section_main_div">
      <h1 className="section_heading">Configure</h1>
      <ConfigurationHeader />

      <form className="form_div" onSubmit={formik.handleSubmit}>
        <div className="form-card">
          <div className="form-elements">
            <CustomInput
              label="Stream IP/URL, in format proto://ip:port"
              id="stream"
              name="stream"
              value={formik.values.stream}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.stream && formik.errors.stream}
              required
            />
          </div>
        </div>

        <div className="text-right">
          <div className="button-div">
            <button type="submit" disabled={formik.isSubmitting}>
              <span>{formik.isSubmitting ? "Saving..." : "Update"}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Audio;
